import React from 'react';
import { shape } from 'prop-types';
import { RatingMeter } from '@one-thd/sui-atomic-components';

export const AttributeRatings = ({ secondaryRatingsAverages: secondaryRatingsAveragesRaw }) => {
  if (!secondaryRatingsAveragesRaw) {
    return '';
  }
  const secondaryRatingsAverages = Object.values(secondaryRatingsAveragesRaw)?.filter((attribute) => attribute);

  return (
    <>
      {!!secondaryRatingsAverages[0]
      && (
        <div data-testid="attribute-ratings" className="sui-flex sui-flex-col">
          <h3 className="sui-font-bold sui-text-lg">Attribute Ratings</h3>
          {(secondaryRatingsAverages).map((val, index) => {
            const averageRatingNumber = Number(val.AverageRating);
            if (averageRatingNumber) {
              return (
                <div
                  key={index}
                  data-testid="attribute-rating"
                  className="sui-flex sui-flex-row sui-justify-between sui-items-center"
                >
                  <span className="sui-text-center sui-h-min"> {val.Id} </span>
                  <RatingMeter value={averageRatingNumber} />
                </div>
              );
            }
            return null;
          })}
        </div>
      )}
    </>
  );
};

AttributeRatings.propTypes = {
  secondaryRatingsAverages: shape({}).isRequired
};